import { Button, Col, Form, Row } from 'antd'
import withSpinning from '../elements/HOC/withSpinning'
import CustomDebounceSelect from '../elements/Select/CustomDebounceSelect'
import withUrlFetch from '../elements/Select/withUrlFetch'
import { get, set, size } from 'lodash'
import { defaultFormItemLayout } from '../modules/FormItems'
import React, { useState } from 'react'
import { compose } from 'recompose'

function SuggestedVendors (props) {
  const { getFieldDecorator, getFieldValue, doc } = props

  const [suggestedVendorsArraySize, setSuggestedVendorsArraySize] = useState(
    size(get(doc, 'suggestedVendors')) || 1,
  )

  const VendorSelect = compose(
    withUrlFetch({
      name: 'suppliers',
      url: `/suppliers`,
    }),
    withSpinning,
  )(CustomDebounceSelect)

  return (
    <Row>
      {Array(suggestedVendorsArraySize)
        .fill()
        .map((_, i) => (
          <Col span={12}>
            <Form.Item label={`Vendor [${i + 1}]`} {...defaultFormItemLayout}>
              {getFieldDecorator(`suggestedVendors[${i}]`, {
                initialValue: get(doc, `suggestedVendors[${i}]`),
              })(
                <VendorSelect
                  keyAtr={'owner'}
                  valueAtr={'fn'}
                  placeholder={`Vendor [${i + 1}]`}
                  style={{ width: '80%' }}
                />,
              )}
              <Button
                style={{ marginLeft: 5 }}
                type="danger"
                size="small"
                onClick={() => {
                  let emails = getFieldValue(`suggestedVendors`)
                  console.log({ emails })
                  emails.splice(i, 1)
                  console.log({ emails })
                  set(doc, `suggestedVendors`, emails)
                  setSuggestedVendorsArraySize(suggestedVendorsArraySize - 1)
                }}>
                Remove
              </Button>
            </Form.Item>
          </Col>
        ))}
      <Col span={12}>
        <Button
          type={'primary'}
          size="small"
          style={{ marginLeft: 10 }}
          icon={'plus'}
          onClick={() => setSuggestedVendorsArraySize(suggestedVendorsArraySize + 1)}>
          Add Suggested Vendor
        </Button>
      </Col>
    </Row>
  )
}

export default SuggestedVendors
